function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { range } from '@finect/front-utils/range';
import { H2 } from '@finect/tabular-core/Headings';
import { withUXPreferences } from '@finect/front-core/withUXPreferences';
import { Section, Expanded } from '../../Section';
import { Tabs, TabsPane } from '../../Tabs';
import { PerformanceColumnsChart, FundPerformanceTable } from '../../Products';
import { Performance } from '../../Products/Charts/Performance';
import { InnerSpacing } from './partials';
var periodsFields = [{
  id: 'performance',
  period: 'M0',
  label: 'Año actual'
}, {
  id: 'performance',
  period: 'M12',
  label: 'Un año'
}, {
  id: 'performance',
  period: 'M24',
  label: '2 años'
}, {
  id: 'performance',
  period: 'M36',
  label: '3 años'
}, {
  id: 'performance',
  period: 'M60',
  label: '5 años'
}, {
  id: 'performance',
  period: 'M120',
  label: '10 años'
}];
export var FundPerformanceCharts = function (_React$Component) {
  _inherits(FundPerformanceCharts, _React$Component);
  var _super = _createSuper(FundPerformanceCharts);
  function FundPerformanceCharts() {
    var _this;
    _classCallCheck(this, FundPerformanceCharts);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleChangeMode", function () {
      var _this$props$uxPrefere = _this.props.uxPreferencesParams.dataUXViewType,
        dataUXViewType = _this$props$uxPrefere === void 0 ? 'chart' : _this$props$uxPrefere;
      var newValue = dataUXViewType === 'table' ? 'chart' : 'table';
      _this.props.uxPreferencesFunctions.setParam('dataUXViewType', newValue);
    });
    return _this;
  }
  _createClass(FundPerformanceCharts, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        product = _this$props.product,
        uxPreferencesParams = _this$props.uxPreferencesParams,
        bottomMargin = _this$props.bottomMargin,
        category = _this$props.category;
      var _uxPreferencesParams$ = uxPreferencesParams.dataUXViewType,
        dataUXViewType = _uxPreferencesParams$ === void 0 ? 'chart' : _uxPreferencesParams$;
      var fund = product.entity;
      var numYears = 10;
      var years = range(numYears, new Date().getFullYear() - numYears + 1);
      var action = dataUXViewType === 'table' ? 'Ver gráfico' : 'Ver tabla';
      var icon = dataUXViewType === 'table' ? 'chart' : 'list';
      return React.createElement(Section, {
        title: "Rentabilidad",
        actions: [{
          action: action,
          icon: icon,
          onAction: this.handleChangeMode
        }],
        bottomMargin: bottomMargin || false
      }, React.createElement(Tabs, null, React.createElement(TabsPane, {
        title: "Por periodos"
      }, React.createElement("div", null, dataUXViewType === 'chart' ? React.createElement(PerformanceColumnsChart, {
        footerNotesLeft: "* Calculada en euros",
        footerNotes: "Rentabilidades medias anuales en los periodos superiores a un a\xF1o.",
        product: product,
        fields: periodsFields
      }) : React.createElement(FundPerformanceTable, {
        footerNotesLeft: "* Calculada en euros",
        footerNotes: "Rentabilidades medias anuales en los periodos superiores a un a\xF1o.",
        category: category,
        product: product,
        fields: periodsFields,
        dimensions: ['performance', 'standardDeviation']
      }))), React.createElement(TabsPane, {
        title: "Por a\xF1os"
      }, React.createElement("div", null, dataUXViewType === 'chart' ? React.createElement(PerformanceColumnsChart, {
        footerNotesLeft: "* Calculada en la divisa del valor liquidativo",
        product: product,
        fields: years.map(function (year) {
          return {
            id: 'yearlyPerformance',
            year: year,
            format: 'chart'
          };
        })
      }) : React.createElement(FundPerformanceTable, {
        footerNotesLeft: "* Calculada en la divisa del valor liquidativo",
        product: product,
        fields: years.map(function (year) {
          return {
            id: 'yearlyPerformance',
            year: year,
            format: 'table'
          };
        })
      })))), React.createElement(Expanded, null, React.createElement(InnerSpacing, null, React.createElement(Tabs, {
        initial: 0
      }, React.createElement(TabsPane, {
        title: "Mensuales"
      }, React.createElement(H2, null, "Rentabilidades mensuales"), React.createElement(Performance, {
        key: "chart-monthly-fund-".concat(fund.id),
        product: fund,
        period: "month"
      })), React.createElement(TabsPane, {
        title: "Anuales"
      }, React.createElement(H2, null, "Rentabilidades anuales"), React.createElement(Performance, {
        key: "chart-yearly-fund-".concat(fund.id),
        product: fund,
        period: "year"
      }))))));
    }
  }]);
  return FundPerformanceCharts;
}(React.Component);
export default withUXPreferences(FundPerformanceCharts);